<template>
    <div class="detail">
        <el-dialog title="商品详情" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <div class="content" v-loading="load">
                <el-table :data="tableDataD" style="width: 100%">
                    <el-table-column prop="id" label="商品ID" width="80" align="center"> </el-table-column>
                    <el-table-column prop="tits" label="商品名称" width="180" align="center"> </el-table-column>
                    <el-table-column prop="sku_title" label="商品规格(sku)" align="center">
                        <template slot-scope="scope">
                            {{ !!scope.row.sku_title ? scope.row.sku_title : "单规格" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="价格" align="center">
                        <template slot-scope="scope">
                            <p>销售价：{{ scope.row.prices_mains }}</p>
                            <p>成本价：{{ scope.row.prices_cbj }}</p>
                            <p>市场价：{{ scope.row.prices_defaults }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchandise_inventory" label="库存" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.goods_specifications_type_id == 1 ? scope.row.merchandise_inventory : scope.row.sku_merchandise_inventory }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="retail_price" label="活动价格(元)" align="center" width="190">
                        <template slot-scope="scope">
                            <el-input-number :disabled="!!showLiskId" v-model="scope.row.retail_price" :min="0"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="repertory" label="活动库存" width="190" align="center">
                        <template slot-scope="scope">
                            <el-input-number :disabled="!!showLiskId" v-model="scope.row.repertory" :min="0" :max="getMax(scope.row)"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <div v-if="!showLiskId">
                    <el-button @click="previous" type="info" plain>上一步</el-button>
                    <el-button type="primary" @click="postDetailData">确 定</el-button>
                </div>
                <div v-else>
                    <el-button @click="closeDetail" plain>关 闭</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            tableDataD: [],
            load: false,
            showLiskId: null,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.$Bus.$on("showLinkGoods", (id) => {
            this.getLinkGoodsList(id);
        });
    },
    methods: {
        ...mapActions({
            linkGoodsList: "commodity/linkGoodsList",
        }),
        getMax(row) {
            if (row.goods_specifications_type_id == 1) {
                return row.merchandise_inventory > 0 ? Number(row.merchandise_inventory - 1) : Number(row.merchandise_inventory);
            } else {
                return row.sku_merchandise_inventory > 0 ? Number(row.sku_merchandise_inventory - 1) : Number(row.sku_merchandise_inventory);
            }
        },
        getLinkGoodsList(id) {
            this.showLiskId = id;
            this.dialogVisible = true;
            this.load = true;
            let opt = {
                token: this.getToken,
                activity_merchant_id: id,
            };
            this.linkGoodsList(opt).then((res) => {
                this.tableDataD = [];
                this.load = false;
                // console.log(res);
                if (res.code == 1) {
                    res.data.forEach((v) => {
                        let opt = {
                            id: v.goods_mains_id,
                            tits: v.name,
                            sku_title: v.spec_name,
                            prices_mains: v.old_prices_mains,
                            prices_cbj: v.old_prices_cbj,
                            prices_defaults: v.old_prices_defaults,
                            sku_merchandise_inventory: v.old_merchandise_inventory,
                            repertory: v.repertory,
                            retail_price: v.retail_price,
                        };
                        this.tableDataD.push(opt);
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        closeDetail() {
            this.showLiskId = null;
            this.tableDataD = [];
            this.dialogVisible = false;
        },
        // 选择的数据格式处理
        BindData(list) {
            console.log(list);
            console.log(this.tableDataD);
            let arr = [];
            if (list && list.length > 0) {
                list.forEach((item) => {
                    if (item.goods_specifications_type_id == 1) {
                        arr.push(item);
                    } else {
                        if (this.tableDataD.length > 0) {
                            this.tableDataD.forEach((o) => {
                                item.id_list.forEach((v) => {
                                    if (!!o.sku_id && o.sku_id == v.id) {
                                        v.repertory = o.repertory;
                                        v.retail_price = o.retail_price;
                                    }
                                });
                            });
                        }
                        item.id_list.forEach((v, i) => {
                            let obj = JSON.parse(JSON.stringify(item));
                            obj.sku_title = obj.id_list[i].title;
                            obj.repertory = obj.id_list[i].repertory;
                            obj.retail_price = obj.id_list[i].retail_price;
                            obj.sku_id = obj.id_list[i].id;
                            obj.sku_merchandise_inventory = obj.id_list[i].merchandise_inventory;
                            arr.push(obj);
                        });
                    }
                });
            }
            this.tableDataD = arr;
        },
        // 上一步
        previous() {
            this.dialogVisible = false;
            this.$emit("previous");
        },
        // 关闭
        handleClose() {
            this.dialogVisible = false;
            this.showLiskId = null;
        },
        postDetailData() {
            let f = this.tableDataD.some((item) => {
                return item.repertory == undefined;
            });
            let t = this.tableDataD.some((item) => {
                return item.retail_price == undefined;
            });
            if (f || t) {
                return this.$message.warning("库存或价格不能为空!");
            }
            this.$emit("postDetailData", this.tableDataD);
            this.dialogVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.detail {
    .content {
        ::v-deep .el-table__body-wrapper {
            height: 400px !important;
            overflow-y: auto;
        }
    }
    ::v-deep .el-table__body-wrapper {
        border-bottom: none;
    }
    ::v-deep .el-table::before {
        display: none;
    }
    ::v-deep .el-input-number {
        width: 140px;
    }
}
</style>